import { Box, Grid } from "@mui/material";
import DriverAlertDataDashboardTiles from "../components/DriverAlertDataDashboardTiles";
import DriversByAlertsScoreChart from "../components/DriversByAlertsScoreChart";
import DriverByAlertsGraph from "../components/DriverByAlertsGraph";
import AlertAndWarnings from "../../Vehicle-Alerts/components/AlertsData";
import DriverByAlertDashboardHeader from "../components/DriverByAlertDasboardHeader";
import DriverAlertsData from "../components/DriverAlertsData";
import { useEffect, useState } from "react";
import { CoPresentOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import DriverCoachingDataTable from "../../Driver-Coaching/components/DriverCoachingDataTable";
import { API_ENDPOINTS } from "packages/novous_web/src/api/endpoints";
import { useAuth } from "packages/novous_web/src/authContext/useAuth";
import useAxios from "packages/novous_web/src/api/useAxios";

type ColumnObjType = {
    [key: string]: {
        name: string;
        status: boolean;
    };
};

export default function DriverAlertDashboard() {
    const [alertColorMapping, setAlertColorMapping] = useState<{ [key: string]: string }>({});
    const today = dayjs();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const driverId: any = params.get('driverId');
    const driverName = params.get('driverName');
    const employeeId = params.get('employeeId');
    const startDate = params.get('startDate');
    const endDate = params.get('endDate');
    const fromCoaching = params.get('fromCoaching') === 'true';
    const selectedDuration = params.get('selectedDuration');
    const [dateState, setDateState] = useState({ startDate: startDate ?? today.format("YYYY-MM-DD"), endDate: endDate ?? today.format("YYYY-MM-DD"), selectedDuration: selectedDuration ?? '' });
    const [tileData, setTilesData] = useState<ColumnObjType>()
    const { user } = useAuth();
    const handleTiles = (data: ColumnObjType) => {
        setTilesData(data)
    }
    const { data: alertData, fetchData: fetchAlertData } = useAxios<any>(
        `${API_ENDPOINTS.alarm.DRIVER_ALERT_TREND_CHART}`,
        "POST"
    );
    useEffect(() => {
        fetchAlertData({ fleetId: user?.customer_id, driverId: driverId, parentId: user?.parentId, startDate: dateState.startDate, endDate: dateState.endDate })
    }, [dateState])
    useEffect(() => {
        if (alertData) {
            console.log('alertData', alertData);
            const driverAlertChartData = alertData?.data?.alertNameWithValueList?.map((alert: { alertName: any; alertValue: any; }, index: string | number) => ({
                warningName: alert.alertName,
                colorCode: alertData.data.coloursName[index] || "grey", // Use the color from coloursName or default to "grey"
                value: alert.alertValue,
            }));
            const colorMap: { [key: string]: string } = {};
            driverAlertChartData.forEach((item: { warningName: string | number; colorCode: string; }) => {
                colorMap[item.warningName] = item.colorCode;
            });
            setAlertColorMapping(colorMap)
        }
    }, [alertData])
    return (
        <Box sx={{ flexGrow: 1, mt: 4 }}>
            <DriverByAlertDashboardHeader setDateState={setDateState} driverName={driverName} employeeId={employeeId} previousSelectedDuration={selectedDuration} dateState={dateState} />
            <Box key={`${dateState.startDate}-${dateState.endDate}`}>
                <DriverAlertDataDashboardTiles dateState={dateState} driverId={driverId} />
                <Grid container spacing={2} sx={{ mt: 4 }}>
                    <Grid item xs={12} sm={6}>
                        <DriversByAlertsScoreChart
                            totalDrivers={1002}
                            title="Driver Summary Incident By Critical Alerts"
                            dateState={dateState}
                            driverId={driverId}
                            alertColorMapping={alertColorMapping}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/* <DriverByAlertsGraph driverId={driverId} dateState={dateState} /> */}
                        <DriverByAlertsGraph driverId={driverId} dateState={dateState} 
                        alertColorMapping={alertColorMapping} />
                    </Grid>
                </Grid>
                {!fromCoaching &&
                    <DriverAlertsData dateState={dateState} driverId={driverId} />
                }
                {fromCoaching &&
                    <DriverCoachingDataTable
                        handleTile={handleTiles}
                        fromCoaching={fromCoaching}
                        dateState={dateState}
                        selectedDriverId={driverId}
                    />
                }
            </Box>
        </Box>
    );
}